import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageBackground from '../components/PageBackgroundBeam';
import PageFooter from '../components/PageFooter';
import './PageRankingHistorico.css';
import './PageRankingInversion.css';

const ORIGEN_LABELS = { 1: 'DOM', 2: 'TRANS', 3: 'GOB', 4: 'POL' };
const ORIGEN_CLASSES = { 1: 'origen-dom', 2: 'origen-trans', 3: 'origen-gob', 4: 'origen-pol' };

const data = [
  { anunciante: 'GRUPO INTUR',              origen: 1, ranks: [1,  1,  1,  1,  2,  3],  inv: [27378923, 27610628, 20955844, 18713130, 18410852, 15360430] },
  { anunciante: 'SERCOM DE HONDURAS',        origen: 2, ranks: [2,  2,  2,  5,  7,  6],  inv: [15760524, 16612513, 13004506, 11794723, 10211931, 9065004] },
  { anunciante: 'LOTELHSA',                  origen: 1, ranks: [3,  23, 35, 30, 30, 18], inv: [14254912, 3783177, 2296891, 2153931, 2419709, 3243840] },
  { anunciante: 'CELTEL',                    origen: 2, ranks: [4,  4,  4,  6,  6,  7],  inv: [12871995, 10779385, 10823517, 9465206, 10878041, 7984719] },
  { anunciante: 'GENOMMA LAB',               origen: 2, ranks: [5,  5,  5,  2,  3,  1],  inv: [12781686, 10729768, 9081975, 16166563, 17716525, 23397402] },
  { anunciante: 'GRUPO CONTINENTAL',          origen: 1, ranks: [6,  10, 8,  20, 22, 13], inv: [11587643, 7817810, 8114851, 3620171, 3534754, 3636204] },
  { anunciante: 'CORPORACION DINANT',         origen: 1, ranks: [7,  6,  13, 22, 26, 21], inv: [11431336, 10142600, 6330215, 2895317, 2716756, 2755090] },
  { anunciante: 'BAC CREDOMATIC',             origen: 2, ranks: [8,  9,  9,  8,  29, 16], inv: [10869232, 8836098, 7125731, 7823520, 2428174, 3337276] },
  { anunciante: 'BANCO ATLANTIDA',            origen: 1, ranks: [9,  8,  3,  4,  5,  4],  inv: [9569949, 8846003, 11941465, 11299656, 11879686, 13401456] },
  { anunciante: 'SUPERMERCADOS LA COLONIA',   origen: 1, ranks: [10, 7,  7,  15, 13, 11], inv: [8442330, 9609275, 4880194, 8138251, 5355640, 5227741] },
  { anunciante: 'GRUPO FINANCIERO FICOHSA',   origen: 1, ranks: [11, 3,  6,  7,  9,  9],  inv: [7584324, 11821741, 8986975, 8430215, 8399230, 7382853] },
  { anunciante: 'DIUNSA',                     origen: 1, ranks: [12, 15, 15, 17, 19, 23], inv: [5759164, 5886366, 4555320, 4428123, 4178747, 2638413] },
  { anunciante: 'BANPAIS',                    origen: 1, ranks: [13, 11, 10, 16, 27, 25], inv: [5419744, 7094674, 4622643, 7068525, 2618379, 2130423] },
  { anunciante: 'GRUPO SALINAS',              origen: 2, ranks: [14, 29, 18, 9,  12, 8],  inv: [5362913, 3224186, 7705940, 3939919, 5535267, 7824874] },
  { anunciante: 'PARTIDO LIBRE',              origen: 4, ranks: [15, null, null, null, null, null], inv: [5318908, 197350, 387, 125015, 887502, 86] },
  { anunciante: 'CARRION',                    origen: 1, ranks: [16, 14, 36, null, null, null], inv: [5099846, 6361860, 2292218, 245939, 440, 0] },
  { anunciante: 'UNICOMER',                   origen: 2, ranks: [17, 19, 17, 29, null, null], inv: [5037232, 4895129, 2461548, 3973956, 969049, 743885] },
  { anunciante: 'FARMAMEDICA',                origen: 2, ranks: [18, 16, 16, 13, 15, 19], inv: [4649681, 5322415, 5494693, 4178924, 4576608, 2821389] },
  { anunciante: 'FARMA FACIL',                origen: 1, ranks: [19, 28, null, null, null, null], inv: [4471524, 3253768, 0, 251029, 0, 0] },
  { anunciante: 'FARMACITY',                  origen: 1, ranks: [20, null, null, 41, null, null], inv: [4292753, 1562020, 1492607, 44950, 1727, 1093] },
  { anunciante: 'ESPRESSO AMERICANO',         origen: 1, ranks: [21, 22, 33, 37, 40, null], inv: [3920233, 3920475, 1646444, 2377222, 1786911, 728658] },
  { anunciante: 'INFARMA',                    origen: 1, ranks: [22, 12, 11, 14, 11, 17], inv: [3755808, 6639398, 6637509, 4950703, 5768094, 3283632] },
  { anunciante: 'BANCO DE OCCIDENTE',         origen: 1, ranks: [23, 20, 25, 12, 21, 14], inv: [3730227, 4671164, 3044871, 5986189, 3768474, 3569755] },
  { anunciante: 'NESTLE',                     origen: 2, ranks: [24, 49, 30, 21, 14, 10], inv: [3636819, 1791090, 2919903, 2530276, 4831737, 6114010] },
  { anunciante: 'PROIMA HONDURAS',            origen: 1, ranks: [25, null, null, null, null, null], inv: [3568569, 940376, 223042, 104173, 29127, 2474] },
];

const years = [2025, 2024, 2023, 2022, 2021, 2020];

function getRankClass(rank) {
  if (rank === null) return 'rank-out';
  if (rank <= 3) return 'rank-top3';
  if (rank <= 10) return 'rank-top10';
  if (rank <= 25) return 'rank-top25';
  return 'rank-out';
}

function getTrendIcon(ranks) {
  const r2025 = ranks[0];
  const r2024 = ranks[1];
  if (r2024 === null) return { icon: 'NEW', cls: 'trend-new' };
  if (r2025 < r2024) return { icon: '\u25B2', cls: 'trend-up' };
  if (r2025 > r2024) return { icon: '\u25BC', cls: 'trend-down' };
  return { icon: '\u25CF', cls: 'trend-same' };
}

function formatCompact(n) {
  if (n >= 1000000) return (n / 1000000).toFixed(1) + 'M';
  if (n >= 1000) return (n / 1000).toFixed(0) + 'K';
  return n.toString();
}

function Sparkline({ inv }) {
  // inv is [2025, 2024, 2023, 2022, 2021, 2020] — reverse for chronological order
  const chronological = [...inv].reverse(); // [2020, 2021, 2022, 2023, 2024, 2025]
  const inv2025 = inv[0];
  const inv2020 = inv[5];
  const isUp = inv2025 >= inv2020;
  const color = isUp ? '#4ade80' : '#f87171';

  const w = 120;
  const h = 40;
  const padX = 4;
  const padY = 6;

  const max = Math.max(...chronological);
  const min = Math.min(...chronological);
  const range = max - min || 1;

  const points = chronological.map((val, i) => {
    const x = padX + (i / (chronological.length - 1)) * (w - padX * 2);
    const y = padY + (1 - (val - min) / range) * (h - padY * 2);
    return `${x},${y}`;
  });

  const polyline = points.join(' ');

  // Area fill under the line
  const firstX = padX;
  const lastX = padX + (w - padX * 2);
  const areaPoints = `${firstX},${h - padY} ${polyline} ${lastX},${h - padY}`;

  return (
    <div className="sparkline-container">
      <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} className="sparkline-svg">
        <defs>
          <linearGradient id={`grad-${isUp ? 'up' : 'down'}`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity="0.3" />
            <stop offset="100%" stopColor={color} stopOpacity="0.02" />
          </linearGradient>
        </defs>
        <polygon
          points={areaPoints}
          fill={`url(#grad-${isUp ? 'up' : 'down'})`}
        />
        <polyline
          points={polyline}
          fill="none"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {/* End dot */}
        {(() => {
          const lastPoint = points[points.length - 1].split(',');
          return (
            <circle cx={lastPoint[0]} cy={lastPoint[1]} r="2.5" fill={color} />
          );
        })()}
      </svg>
      <span className={`sparkline-value ${isUp ? 'spark-up' : 'spark-down'}`}>
        ${formatCompact(inv2025)}
      </span>
    </div>
  );
}

function PageRankingInversion() {
  const navigate = useNavigate();

  return (
    <PageBackground>
      <div className="ranking-page">
        <header className="ranking-header">
          <button className="btn-back" onClick={() => navigate('/top25-anunciantes')}>
            &#8592; Top 25
          </button>
          <div className="ranking-title-block">
            <h1 className="ranking-title">Ranking &amp; Inversi&oacute;n</h1>
            <p className="ranking-subtitle">Evoluci&oacute;n de posici&oacute;n e inversi&oacute;n &middot; Top 25 Anunciantes &middot; Honduras 2020–2025</p>
          </div>
          <img src={require('../assets/logo-publisearch.png')} alt="Publisearch" className="header-logo-inline" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />
        </header>

        <nav className="ranking-nav">
          <button
            className="year-btn"
            onClick={() => navigate('/top25-anunciantes')}
          >
            Top 25
          </button>
          <button
            className="year-btn year-btn-active"
            onClick={() => navigate('/ranking-inversion')}
          >
            Ranking &amp; Inversi&oacute;n
          </button>
        </nav>

        <div className="ranking-legend">
          <span className="legend-item"><span className="legend-dot legend-top3"></span>Top 3</span>
          <span className="legend-item"><span className="legend-dot legend-top10"></span>Top 10</span>
          <span className="legend-item"><span className="legend-dot legend-top25"></span>Top 25</span>
          <span className="legend-item"><span className="legend-dot legend-out"></span>Fuera del Top 25</span>
          <span className="legend-sep"></span>
          <span className="legend-item"><span className="legend-line legend-line-up"></span>Crecimiento vs 2020</span>
          <span className="legend-item"><span className="legend-line legend-line-down"></span>Decrecimiento vs 2020</span>
        </div>

        <div className="ranking-table-wrapper">
          <table className="ranking-table">
            <thead>
              <tr>
                <th className="rk-col-pos">#</th>
                <th className="rk-col-name">Anunciante</th>
                <th className="rk-col-origen">Origen</th>
                <th className="rk-col-trend"></th>
                {years.map(y => (
                  <th key={y} className={`rk-col-year ${y === 2025 ? 'rk-col-current' : ''}`}>{y}</th>
                ))}
                <th className="rk-col-spark">Inversi&oacute;n 6Y</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, idx) => {
                const trend = getTrendIcon(row.ranks);
                return (
                  <tr key={idx} className="rk-row" style={{ animationDelay: `${idx * 0.04}s` }}>
                    <td className="rk-col-pos">
                      <span className="rk-pos-badge">{idx + 1}</span>
                    </td>
                    <td className="rk-col-name">{row.anunciante}</td>
                    <td className="rk-col-origen">
                      <span className={`origen-badge ${ORIGEN_CLASSES[row.origen] || ''}`}>
                        {ORIGEN_LABELS[row.origen] || '-'}
                      </span>
                    </td>
                    <td className="rk-col-trend">
                      <span className={`trend-badge ${trend.cls}`}>{trend.icon}</span>
                    </td>
                    {row.ranks.map((rank, i) => (
                      <td key={i} className={`rk-col-year ${years[i] === 2025 ? 'rk-col-current' : ''}`}>
                        <span className={`rank-cell ${getRankClass(rank)}`}>
                          {rank !== null ? rank : '-'}
                        </span>
                      </td>
                    ))}
                    <td className="rk-col-spark">
                      <Sparkline inv={row.inv} />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <PageFooter />
      </div>
    </PageBackground>
  );
}

export default PageRankingInversion;
